import { QRCodeSVG } from 'qrcode.react'

function QRComponent(props) {

 

    return (
        <>
            <QRCodeSVG
                // value={"redirecrUrl"}
            //  value={"https://sb-ar-test-bc92c.web.app/mobile/units/unit?unitIndex=1&modelName=flagellum"}
            //  value={"https://sb-ar-test-bc92c.web.app/"}

               value={"https://dev-001.smart-biology.com/app-redirect"}
                // value={"https://www.smart-biology.com/apple-app-site-association"}
                // value={"https://3000-firebase-sb-uigit-1753995171734.cluster-vyr53kd25jc2yvngldrwyq6zc4.cloudworkstations.dev/app-redirect"}
                title={props.lessonName + " " + props.lessonId}
                size={128}
                bgColor={"#ffffff"}
                fgColor={"#000000"}
                level={"H"}
                marginSize={0}
                //https://sb-ar-test-bc92c.web.app/mobile/units/unit?unitIndex=1&modelName=flagellum
                imageSettings={{
                    src: "https://storage.googleapis.com/sb-general/sb_test_001.png",
                    x: undefined,
                    y: undefined,
                    height: 30,
                    width: 40,
                    opacity: 1,
                    excavate: true,
                }}
            />

        </>
    )
}

export default QRComponent;